module.exports = __webpack_public_path__ + "static/media/IC204renew.c922a482.jpg";